'use strict';
var React = require('react');
var _ = require('underscore');
var assetsHelper = require('../helper/assetsHelper');

var CustomSelect = React.createClass({
  propTypes: {
    value: React.PropTypes.number.isRequired,
    onChange: React.PropTypes.func.isRequired
  },
  getInitialState: function () {
    return {
      expand: false
    };
  },
  render: function () {
    var items = [
      {
        value: '0.33',
        display: "33%",
      },
      {
        value: '0.5',
        display: '50%'
      },
      {
        value: '0.66',
        display: '66%'
      },
      {
        value: '0.8',
        display: '88%'
      },
      {
        value: '1',
        display: '100%'
      },
      {
        value: '1.25',
        display: '125%'
      },
      {
        value: '1.5',
        display: '150%'
      },
      {
        value: '2',
        display: '200%'
      },
      {
        value: '3',
        display: '300%'
      }
    ];
    var value = this.props.value.toString();
    var selected = _.find(items, function (item) {
      return item.value === value;
    });
    return (
      <div className="custom-select">
        <img className="custom-select-bg" src={assetsHelper.getAsset('select_bg.png')}/>
        <img className="custom-select-drop" src={assetsHelper.getAsset('combobox.png')}/>
        <span onClick={this.onToggleDropdown} className="label">{selected.display}</span>
        <ul
          style={{
            display: this.state.expand ? 'block' : 'none'
          }}
          className="custom-select-options">
          {items.map(function (item) {
            if (item === selected) {
              return (
                <li className="current" key={item.value}
                    onClick={this.onChange.bind(this, item.value)}>{item.display}</li>
              );
            }
            return (
              <li key={item.value} onClick={this.onChange.bind(this, item.value)}>{item.display}</li>
            );
          }, this)}
        </ul>
      </div>
    );
  },
  onChange: function (val) {
    this.props.onChange(parseFloat(val));
    this.setState({
      expand: false
    });
  },
  onToggleDropdown: function () {
    this.setState({
      expand: !this.state.expand
    });
  }
});

module.exports = CustomSelect;


/** WEBPACK FOOTER **
 ** ./src/views/CustomSelect.jsx
 **/